import React, { useEffect, useMemo, useRef, useState } from "react";
import Img from "../../../../../components/Img";
import AbLogo from "../../../../../assets/abGoldenLogo.png";
import CroppedImageFromFile from "../../../../../components/formComponents/CroppedImage";
import {
  getImageUrls,
  getMinioImage,
  getTopColorsFromMultipleUrls,
} from "../../../../../utils/helpers";
import siteBg from "../../../../../assets/siteBg.png";
import watermark from "../../../../../assets/water.png";
import { areaDescription, designStyle } from "../../../../../utils/options";
import { CreatedBy } from "../PublicViewRender";
import { Icon } from "@iconify/react/dist/iconify.js";
import { CroppedPreview } from "./ImgUploadDesignLib";
import Disclamer from "../Disclamer";
import { ImageLayout } from "../SiteFeasibility/FormImagesLayout";
import classNames from "classnames";
import ImgOptimized from "../../../../../components/ImgOptimized";

const ImgGrid = ({
  images,
  companyLogo,
  areaName,
  coordinates,
  floorMap,
  isPublicView,
  isPdfView,
  isPdf,
  selectedDesignStyle,
  selectedDesignBg,
  isShowCreatedBy,
  isActiveImg,
  selection1 = {},
  selection2 = {},
  selection3 = {},
  selection4 = {},
  handleActiveImg = () => {},
  order = [],
  containerWidth = null,
}) => {
  console.log("ASDF", { images });
  const [coloPalletes, setColorPalletes] = useState([]);
  // const [ABSIZE, setABSIZE] = useState('32px');
  const ref = useRef(null);
  const barRef = useRef(null);
  const GRID_WIDTH = containerWidth || ref?.current?.clientWidth || 800;
  const HEADING_SIZE = `${Math.max(Math.min(40, GRID_WIDTH / 35.18), 16)}px`;
  const ABSIZE = `${Math.max(Math.min(40, GRID_WIDTH / 35.18), 16) * (containerWidth < 640 ? 1.75 : 1.45)}px`;
  const HEIGHT = GRID_WIDTH / 1.77;
  const [baseImages, setBase64Images] = useState({
    companyLogo: "",
    floorMap: "",
    images: [],
  });
  images = useMemo(() => {
    const designImg = images.filter(
      (v) =>
        v.includes("static") || v.includes("minio/project-showcase/materials"),
    );
    const uploadedImgs = images.filter(
      (v) =>
        !v.includes("static") &&
        !v.includes("minio/project-showcase/materials"),
    );

    let d = 0,
      u = 0;
    let sortedImages = [];
    for (let i = 0; i < order.length; i++) {
      let isDesign = order[i][order[i].length - 1] == "0";
      let imgIdx = order[i][0];
      if (isDesign) {
        sortedImages.push(designImg?.[imgIdx]);
        d++;
      } else {
        sortedImages.push(uploadedImgs?.[imgIdx]);
        u++;
      }
    }
    return sortedImages?.length ? sortedImages : images;
  }, [images, order]);
  // images= images.filter(i => i)
  // images = sortedImages?.length ? sortedImages : images;

  // console.log({ order, images, floorMap});
  console.log("IMAGES IN GRID", {
    images,
    companyLogo,
    areaName,
    coordinates,
    floorMap,
    baseImages,
    selection1,
    selection2,
    selection3,
    selection4,
    ref: GRID_WIDTH,
    ABSIZE,
  });
  const getBase64ImageFromUrl = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";

      img.onload = function () {
        try {
          // Ensure image is fully loaded
          if (img.complete && img.naturalWidth > 0 && img.naturalHeight > 0) {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext("2d");

            // Clear canvas with white background
            // ctx.fillStyle = "#FFFFFF";
            // ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Draw image
            ctx.drawImage(img, 0, 0);

            // Convert to base64 with error handling
            try {
              const dataURL = canvas.toDataURL("image/png");
              if (dataURL && dataURL.startsWith("data:image/")) {
                console.log(
                  `Successfully converted image: ${url.substring(0, 50)}...`,
                );
                resolve(dataURL);
              } else {
                throw new Error("Invalid data URL generated");
              }
            } catch (canvasError) {
              console.error("Canvas conversion failed:", canvasError);
              resolve(url); // Fallback to original URL
            }
          } else {
            console.error("Image not properly loaded:", url);
            resolve(url); // Fallback to original URL
          }
        } catch (error) {
          console.error("Error in image processing:", error);
          resolve(url); // Fallback to original URL
        }
      };

      img.onerror = function (e) {
        console.error("Failed to load image:", url, e);
        resolve(url); // Fallback to original URL
      };

      // Add timeout to prevent hanging
      setTimeout(() => {
        if (!img.complete) {
          console.warn("Image loading timeout:", url);
          resolve(url); // Fallback to original URL
        }
      }, 10000); // 10 second timeout

      img.src = url;
    });

  async function setBase64() {
    try {
      const baseCLogo = await getBase64ImageFromUrl(companyLogo);
      const baseFloorMap = await getBase64ImageFromUrl(
        getImageUrls([floorMap], true, true)?.[0],
      );
      const bImages = await Promise.all(
        images.filter((i) => i).map((img) => getBase64ImageFromUrl(img)),
      );
      setBase64Images({
        companyLogo: baseCLogo,
        floorMap: baseFloorMap,
        images: bImages,
      });
    } catch (error) {
      console.error(error.message);
    }
  }

  useEffect(() => {
    if (isPdfView) {
      setBase64();
    }
  }, []);

  useEffect(() => {
    getTopColorsFromMultipleUrls(images, 5)
      .then((data) => {
        console.log("Top colors fetched:", data);
        setColorPalletes(data);
      })
      .catch((err) => console.error("Error fetching top colors", err));
  }, [images]);

  const AllImages = images?.filter((i) => i) || [];

  return (
    <div
      ref={ref}
      style={{
        height: isPdf ? "100%" : isPublicView ? "100%" : `${HEIGHT}px`,
      }}
      className={`flex flex-col relative h-full ${
        isPublicView ? " h-full " : "min-h-96"
      }  bg-white`}
    >
      <div
        ref={barRef}
        style={{
          fontSize: HEADING_SIZE,
        }}
        className={classNames(
          "flex-shrink-0 bg-[#06565E] playfair relative capitalize text-[#EABC9D]  text-center font-bold italic py-1 ",
          HEADING_SIZE,
          "leading-tight",
        )}
      >
        {isPdfView ? (
          <span className="relative bottom-2">
            {areaName.split("-")?.join(" ")}
          </span>
        ) : (
          <>{areaName.split("-")?.join(" ")}</>
        )}

        <div
          className={`flex gap-0.5   justify-start items-center absolute top-0 left-1 ${
            isPdfView ? "mb-2 gap-1.5" : "sm:mb-0"
          } 
          ${isPublicView ? "gap-1.5" : ""}
           sm:mb-0`}
        >
          {/* {ref?.current?.innerWidth} */}
          {!isPdfView ? (
            <ImgOptimized
              // width="100%"
              // height="100%"
              src={AbLogo}
              // height={HEADING_SIZE}
              style={{
                height: ABSIZE,
              }}
              className={` max-w-fit object-cover ${
                ""
                // isPublicView ? "xl:w-[5.2vh] xl:h-[5vh]" : "xl:w-8 xl:h-8"
              }  object-cover rounded-lg`}
            />
          ) : (
            <ImgOptimized
              // width="100%"
              // height="100%"
              src={AbLogo}
              style={{
                height: ABSIZE,
              }}
              className="  max-w-fit"
            />
          )}
        </div>
      </div>
      {companyLogo && (
        <div className="absolute bottom-4 left-2 z-[30]">
          <div className="bg-white rounded-full overflow-hidden flex items-center justify-center p-1 aspect-square">
            {!isPdfView ? (
              <ImgOptimized
                src={companyLogo}
                height={HEADING_SIZE}
                style={{ height: HEADING_SIZE }}
                className="max-w-32 h-auto object-contain"
              />
            ) : (
              <ImgOptimized
                src={baseImages.companyLogo}
                height={HEADING_SIZE}
                style={{ height: HEADING_SIZE }}
                className="max-w-32 h-auto object-contain"
              />
            )}
          </div>
        </div>
      )}

      {AllImages.length > 0 && (
        <div
          className={`grow ${isPdf ? "h-full" : "min-h-0 h-full"}   overflow-hidden relative`}
        >
          <ImageLayout
            allImages={AllImages}
            isPdf={isPdfView}
            isVideo={false}
            isSite={true}
            siteProps={{
              isPdfView,
              isActive: isActiveImg,
              handleActiveImg: isPdfView ? () => {} : handleActiveImg,
            }}
          />
          <div className=" flex flex-col z-[10] gap-1.5 h-fit justify-between items-start  w-fit absolute top-1/2 -translate-y-1/2">
            {coloPalletes
              .filter((_, i) => i <= (AllImages.length == 1 ? 2 : 10))
              ?.map((color, idx) => (
                <div
                  key={idx}
                  style={{ backgroundColor: color, width: GRID_WIDTH / 20 }}
                  className={`flex  relative items-end justify-center gap-1 left-[1px] ${
                    isPdfView ? "left-0.5 text-xs" : ""
                  }   w-16 h-6 rounded-r-md  ${
                    isPublicView
                      ? "text-[0.52rem] lg:h-10"
                      : "text-[0.52rem] lg:h-10"
                  }  px-2 text-white`}
                >
                  {isPdfView ? (
                    <span className="relative bottom-2">{color}</span>
                  ) : (
                    <>{color}</>
                  )}
                </div>
              ))}
          </div>
        </div>
      )}
      {/* <div className="grow min-h-0 grid grid-cols-2">
<div className="w-full h-full overflow-hidden bg-gray-100">

          <ActiveImg
                isPdfView={isPdfView}
                src={AllImages?.[0]}
                // isP0
                handleActiveImg={handleActiveImg}
                isActive={isActiveImg}
                />
                </div>
              
      </div> */}
      {/*  logos */}

      {AllImages && Array.isArray(AllImages) && AllImages.length == 1 && (
        <>
          {Object.keys(selection1).length > 0 && (
            <div
              className={`${
                isPdfView
                  ? "w-40 h-40 top-10"
                  : "w-32 h-32 sm:w-36 sm:h-36 lg:w-24  lg:h-24 xl:w-40   xl:h-40 border border-white/30 top-[27%] -translate-y-1/2 "
              } overflow-hidden rounded-full absolute right-5 flex items-center justify-center  `}
            >
              <CroppedImageFromFile
                imageFile={
                  isPdfView
                    ? baseImages.images?.[0]
                    : AllImages?.[0]?.split("?")?.[0]
                }
                areaData={selection1?.areaData}
                position={selection1?.position}
                radius={selection1?.radius}
              />
            </div>
          )}
          {Object.keys(selection2).length > 0 && (
            <div
              className={`${
                isPdfView
                  ? "w-40 h-40 bottom-10 "
                  : "w-32 h-32 sm:w-36 sm:h-36 lg:w-24  lg:h-24 xl:w-40   xl:h-40 border border-white/30 top-[67%] -translate-y-[40%]"
              }  overflow-hidden rounded-full absolute  left-5 flex items-center justify-center `}
            >
              <CroppedImageFromFile
                imageFile={
                  isPdfView
                    ? baseImages.images?.[0]
                    : AllImages?.[0]?.split("?")?.[0]
                }
                areaData={selection2?.areaData}
                position={selection2?.position}
                radius={selection2?.radius}
              />
            </div>
          )}
          {Object.keys(selection3).length > 0 && (
            <div
              className={`${
                isPdfView
                  ? "w-40 h-40 bottom-10 "
                  : "w-32 h-32 sm:w-36 sm:h-36 lg:w-24  lg:h-24 xl:w-40   xl:h-40 border border-white/30 top-[27%] -translate-y-1/2"
              }  overflow-hidden rounded-full absolute  left-5 flex items-center justify-center `}
            >
              <CroppedImageFromFile
                imageFile={
                  isPdfView
                    ? baseImages.images?.[0]
                    : AllImages?.[0]?.split("?")?.[0]
                }
                areaData={selection3?.areaData}
                position={selection3?.position}
                radius={selection3?.radius}
              />
            </div>
          )}
          {Object.keys(selection4).length > 0 && (
            <div
              className={`${
                isPdfView
                  ? "w-40 h-40 top-10 "
                  : "w-32 h-32 sm:w-36 sm:h-36 lg:w-24  lg:h-24 xl:w-40   xl:h-40 border border-white/30 top-[67%] -translate-y-[40%]"
              }  overflow-hidden rounded-full absolute  right-5 flex items-center justify-center `}
            >
              <CroppedImageFromFile
                imageFile={
                  isPdfView
                    ? baseImages.images?.[0]
                    : AllImages?.[0]?.split("?")?.[0]
                }
                areaData={selection4?.areaData}
                position={selection4?.position}
                radius={selection4?.radius}
              />
            </div>
          )}
        </>
      )}
      {coordinates?.areaData && floorMap && (
        <div
          className={`absolute ${
            isPublicView
              ? "h-26 w-16 sm:w-20 sm:h-20 md:h-20 md:w-20 lg:w-16 lg:h-16 xl:w-24 xl:h-24 2xl:w-32 2xl:h-32"
              : isPdf
                ? " h-24 w-24 "
                : " h-24 w-24 "
          }   border-[2px] border-white rounded-full bottom-2 ${
            images.length == 2 ? "right-2" : "right-2"
          }  z-[9]`}
        >
          <CroppedImageFromFile
            areaData={coordinates?.areaData}
            position={coordinates?.position}
            imageFile={
              isPdfView
                ? baseImages.floorMap
                : getImageUrls([floorMap], true, true)?.[0]
            }
            radius={coordinates?.radius}
          />
        </div>
      )}
      {isShowCreatedBy && (
        <CreatedBy {...isShowCreatedBy} className={"bottom-0 -left-3"} />
      )}
    </div>
  );

  return (
    <div
      style={{
        // backgroundColor: isPublicView ? "transparent" : "white",
        backgroundImage: `url(${selectedDesignBg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        // backgroundOrigin: "content-box",
      }}
      className={`flex relative ${
        isPublicView ? " h-full " : "h-96"
      }  bg-white`}
    >
      {coordinates?.areaData && floorMap && (
        <div
          className={`absolute ${
            isPublicView
              ? "h-26 w-16 sm:w-20 sm:h-20 md:h-32 md:w-32 lg:w-16 lg:h-16 xl:w-24 xl:h-24 2xl:w-32 2xl:h-32"
              : isPdfView
                ? " h-32 w-32 "
                : " h-24 w-24 "
          }   border-[2px] border-white rounded-full bottom-2 ${
            images.length == 2 ? "right-2" : "left-2"
          }  z-[9]`}
        >
          <CroppedImageFromFile
            areaData={coordinates?.areaData}
            position={coordinates?.position}
            imageFile={
              isPdfView
                ? baseImages.floorMap
                : getImageUrls([floorMap], true, true)?.[0]
            }
            radius={coordinates?.radius}
          />
        </div>
      )}
      {/*  <ImgOptimized src={designStyle?.find(v=> v.name == selectedDesignStyle)?.bg ||  siteBg} className="z-[0] absolute top-0 left-0 w-full h-full object-cover" /> */}
      {isPublicView && (
        <ImgOptimized
          src={watermark}
          className="absolute top-1/2 opacity-30 -translate-x-1/2 -translate-y-1/2  left-1/2 w-4/5 z-[9999] pointer-events-none"
          alt=""
          onMouseEnter={(e) => e.stopPropagation()}
        />
      )}
      <div className="basis-1/2 flex flex-col h-full z-[8] ">
        <div
          className={`${
            isPdfView
              ? "h-[40%]"
              : isPublicView
                ? "h-[50%] sm:h-[45%] " //h-[37%] sm:h-[33%] md:h-[30%] lg:h-[40%] xl:h-[37%] 2xl:h-[35%]
                : "h-[50%] sm:h-[38%] md:h-[35%] xl:h-[50%] 2xl:h-[50%]"
          }  flex p-2 pr-0 `}
        >
          <div className={`${images.length > 1 ? "basis-[87.5%]" : "w-full"} `}>
            <div
              className={`flex gap-1.5 justify-start items-center ${
                isPdfView ? "mb-2" : "sm:mb-0"
              }  sm:mb-0`}
            >
              {!isPdfView ? (
                <ImgOptimized
                  // width="100%"
                  // height="100%"
                  src={AbLogo}
                  className={` w-6 h-6 sm:w-6 sm:h-6 lg:w-6 lg:h-6 ${
                    isPublicView ? "xl:w-[5.2vh] xl:h-[5vh]" : "xl:w-8 xl:h-8"
                  }  object-cover rounded-lg`}
                />
              ) : (
                <ImgOptimized
                  // width="100%"
                  // height="100%"
                  src={AbLogo}
                  className=" h-10 max-w-fit"
                />
              )}
              {companyLogo && (
                <>
                  <span className={` `}>x</span>
                  {!isPdfView ? (
                    <>
                      <ImgOptimized
                        src={companyLogo}
                        className={`max-w-fit h-4 sm:h-6 lg:h-4 ${
                          isPublicView ? "xl:h-[5vh]" : "xl:h-8"
                        }   `}
                      />
                    </>
                  ) : (
                    <ImgOptimized
                      width="100%"
                      height="100%"
                      src={baseImages.companyLogo}
                      className="max-w-fit h-10 object-cover "
                    />
                  )}
                </>
              )}
            </div>
            <h2
              className={` ${
                isPdfView
                  ? "mb-1 text-xl relative bottom-2"
                  : ` text-md sm:text-xl md:text-3xl lg:text-xl ${
                      isPublicView
                        ? "xl:text-[4vh] py-0.5 sm:py-1    xl:py-4 xl:pb-6"
                        : "xl:text-3xl"
                    } `
              }
              } italic text-teal-600 z-[100] playfair font-[800] capitalize`}
            >
              {areaName?.split("-")?.join(" ")}
            </h2>
            {images.length > 1 && (
              <div
                className={`${
                  isPdfView
                    ? " text-xs relative bottom-2"
                    : isPublicView
                      ? "  text-[0.5rem] sm:text-xs md:text-[0.8rem] lg:text-sm  2xl:text-lg"
                      : "  text-xs"
                } text-teal-600 italic`}
              >
                {areaDescription[areaName?.split("-")?.join(" ")]}
              </div>
            )}
            {images?.length == 1 && (
              <div className=" flex flex-col z-[100] gap-1.5 h-fit justify-between items-start mt-3 2xl:mt-6 w-full">
                {coloPalletes
                  .filter((_, i) => i <= 2)
                  ?.map((color, idx) => (
                    <div
                      key={idx}
                      style={{ backgroundColor: color }}
                      className={`flex  relative items-end justify-center gap-1 ${
                        isPdfView ? "left-0.5 text-xs" : ""
                      }   w-20 h-10 rounded-r-md right-2 ${
                        isPublicView ? "text-[0.52rem]" : "text-[0.52rem]"
                      }  px-2 text-white`}
                    >
                      {color}
                    </div>
                  ))}
              </div>
            )}
            {/* {images?.length>=3 &&   */}
            {/* grid grid-cols-3 sm:grid-cols-3  lg:grid-cols-3 xl:grid-cols-3 */}

            {/* } */}
          </div>

          {images?.length > 1 && (
            <div className="basis-[12.5%]  h-full pl-1">
              <div className=" flex flex-col z-[100] gap-0.5 h-full justify-between ">
                {coloPalletes
                  // .filter((_, i) => i >= 0)
                  ?.map((color, idx) => (
                    <div
                      key={idx}
                      style={{ backgroundColor: color }}
                      className={`flex  relative items-end justify-center gap-1 ${
                        isPdfView ? "left-0.5 text-xs" : ""
                      }   w-full h-full rounded-l-md ${
                        isPublicView ? "text-[0.52rem]" : "text-[0.52rem]"
                      }  px-2 text-white`}
                    >
                      {color}
                      {/* <div
                      style={{ backgroundColor: color }}
                      className={`${isPdfView ? " w-6 h-6 " :  ` ${images.length ===1 ? "min-w-4 min-h-4 w-4 h-4" : "w-3 h-3 sm:w-4 sm:h-4 lg:w-3 lg:h-3 2xl:w-6 2xl:h-6"} `}   `}
                    ></div> */}
                      {/* <span
                      className={`text-xs md:text-sm lg:text-xs xl:text-sm font-semibold 
                        ${
                        isPdfView && "absolute top-[10%] left-12 mr-5 z-[100] text-base"
                      } 
                        `}
                    >
                      {color}
                    </span> */}
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
        <div
          className={`${
            isPdfView
              ? "h-[60%]"
              : isPublicView
                ? "h-[50%] sm:h-[55%]" //h-[63%] sm:h-[67%] md:h-[70%] lg:h-[60%] xl:h-[63%] 2xl:h-[65%]
                : "h-[50%] sm:h-[62%] md:h-[65%] xl:h-[50%] 2xl:h-[50%]"
          }  overflow-hidden `}
        >
          {images?.length >= 2 && (
            <>
              {/* {isPdfView ? (
                 <ImgOptimized
                  src={
                    images?.length == 2
                      ? baseImages.images?.[1]
                      : baseImages.images?.[0]
                  }
                  width="100%"
                  height="100%"
                  className={
                    "w-full h-full object-cover  overflow-hidden pr-0.5 "
                  }
                />
              ) : (
                <ActiveImg
                  isActive={
                    isActiveImg ==
                    (images?.length == 2 ? images?.[1] : images?.[0])
                  }
                >
                   <ImgOptimized
                    src={images?.length == 2 ? images?.[1] : images?.[0]}
                    width="100%"
                    height="100%"
                    onClick={() =>
                      handleActiveImg(
                        images?.length == 2 ? images?.[1] : images?.[0]
                      )
                    }
                    className={
                      "w-full h-full object-cover  overflow-hidden pr-0.5 hover:scale-105 transition-all duration-300 "
                    }
                  />
                </ActiveImg>
              )} */}
              <ActiveImg
                isPdfView={isPdfView}
                src={images?.length == 2 ? images?.[1] : images?.[0]}
                handleActiveImg={handleActiveImg}
                isActive={isActiveImg}
              />
            </>
          )}
        </div>
      </div>

      {images?.length >= 3 ? (
        <div
          className={`basis-1/2 h-full flex ${
            images.length == 3 ? "flex-col" : "flex-row"
          }   relative`}
        >
          {/* ASDF */}
          <div
            className={`basis-1/2 ${
              images.length == 3 ? "h-1/2" : "h-full"
            }  overflow-hidden `}
          >
            <div
              className={` ${
                images?.[4] ? "h-[60%] " : "h-[100%] "
              }  overflow-hidden `}
            >
              <ActiveImg
                isPdfView={isPdfView}
                src={images?.[1]}
                isP0
                handleActiveImg={handleActiveImg}
                isActive={isActiveImg}
              />
            </div>
            {images?.[4] && (
              <div className="h-[40%]  overflow-hidden">
                <ActiveImg
                  isPdfView={isPdfView}
                  src={images?.[4]}
                  isP0
                  handleActiveImg={handleActiveImg}
                  isActive={isActiveImg}
                />
              </div>
            )}
          </div>
          <div
            className={`basis-1/2 ${
              images.length == 3 ? "h-1/2" : "h-full"
            }  overflow-hidden `}
          >
            <div
              className={` overflow-hidden ${
                images?.[3] ? (images?.[4] ? "h-[40%]" : "h-[50%]") : "h-[100%]"
              }  `}
            >
              <ActiveImg
                isPdfView={isPdfView}
                src={images[2]}
                handleActiveImg={handleActiveImg}
                isActive={isActiveImg}
              />
            </div>
            {images?.[3] && (
              <div
                className={
                  images?.[4]
                    ? "h-[60%] overflow-hidden"
                    : "h-[50%] overflow-hidden"
                }
              >
                <ActiveImg
                  isPdfView={isPdfView}
                  src={images?.[3]}
                  handleActiveImg={handleActiveImg}
                  isActive={isActiveImg}
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          className={` ${
            images.length == 2 ? "basis-1/2" : "basis-2/3 "
          }  h-full flex flex-col relative `}
        >
          <div
            className={`${
              images.length == 2 ? "h-2/3" : "h-full relative right-[40%]  "
            } overflow-hidden `}
          >
            {images?.[0] ? (
              <>
                <ActiveImg
                  isPdfView={isPdfView}
                  src={images?.[0]}
                  handleActiveImg={handleActiveImg}
                  isActive={isActiveImg}
                />
              </>
            ) : (
              <div className="w-full h-full   overflow-hidden p-0.5"></div>
            )}
          </div>
        </div>
      )}

      {images && Array.isArray(images) && images.length == 1 && (
        <>
          {Object.keys(selection1).length > 0 && (
            <div
              className={`${
                isPdfView
                  ? "w-40 h-40 top-10"
                  : "w-32 h-32 sm:w-36 sm:h-36 lg:w-24  lg:h-24 xl:w-40   xl:h-40 border border-white/30 top-[25%] -translate-y-1/2 "
              } overflow-hidden rounded-full absolute right-5 flex items-center justify-center  `}
            >
              <CroppedImageFromFile
                imageFile={
                  isPdfView
                    ? baseImages.images?.[0]
                    : images?.[0]?.split("?")?.[0]
                }
                areaData={selection1?.areaData}
                position={selection1?.position}
                radius={selection1?.radius}
              />
            </div>
          )}
          {Object.keys(selection2).length > 0 && (
            <div
              className={`${
                isPdfView
                  ? "w-40 h-40 bottom-10 "
                  : "w-32 h-32 sm:w-36 sm:h-36 lg:w-24  lg:h-24 xl:w-40   xl:h-40 border border-white/30 top-[70%] -translate-y-[40%]"
              }  overflow-hidden rounded-full absolute  right-5 flex items-center justify-center `}
            >
              <CroppedImageFromFile
                imageFile={
                  isPdfView
                    ? baseImages.images?.[0]
                    : images?.[0]?.split("?")?.[0]
                }
                areaData={selection2?.areaData}
                position={selection2?.position}
                radius={selection2?.radius}
              />
            </div>
          )}
          {Object.keys(selection3).length > 0 && (
            <div
              className={`${
                isPdfView
                  ? "w-40 h-40 bottom-10 "
                  : "w-32 h-32 sm:w-36 sm:h-36 lg:w-24  lg:h-24 xl:w-40   xl:h-40 border border-white/30 top-[25%] -translate-y-1/2"
              }  overflow-hidden rounded-full absolute  left-5 flex items-center justify-center `}
            >
              <CroppedImageFromFile
                imageFile={
                  isPdfView
                    ? baseImages.images?.[0]
                    : images?.[0]?.split("?")?.[0]
                }
                areaData={selection3?.areaData}
                position={selection3?.position}
                radius={selection3?.radius}
              />
            </div>
          )}
          {Object.keys(selection4).length > 0 && (
            <div
              className={`${
                isPdfView
                  ? "w-40 h-40 top-10 "
                  : "w-32 h-32 sm:w-36 sm:h-36 lg:w-24  lg:h-24 xl:w-40   xl:h-40 border border-white/30 top-[70%] -translate-y-[40%]"
              }  overflow-hidden rounded-full absolute  left-5 flex items-center justify-center `}
            >
              <CroppedImageFromFile
                imageFile={
                  isPdfView
                    ? baseImages.images?.[0]
                    : images?.[0]?.split("?")?.[0]
                }
                areaData={selection4?.areaData}
                position={selection4?.position}
                radius={selection4?.radius}
              />
            </div>
          )}
        </>
      )}
      {/* <Disclamer/> */}
      {isShowCreatedBy && (
        <CreatedBy {...isShowCreatedBy} className={"bottom-0 -left-3"} />
      )}
    </div>
  );
};

export const ActiveImg = ({
  children,
  isActive,
  src,
  isPdf,
  handleActiveImg,
  isP0 = false,
  ...props
}) => {
  let isActiveBool = isActive == src;
  if (!src) return <></>;
  console.log({ src }, "SRC");
  return (
    <div className="relative  w-full h-full">
      <div
        onClick={() => handleActiveImg(src)}
        className={`w-full h-full cursor-pointer ${
          !isP0 ? "p-[1px]" : "p-[1px] pl-0"
        }`}
      >
        {/*  <ImgOptimized
                    src={ src}
                    width="100%"
                    height="100%"
                    
                    className={
                      "w-full h-full object-cover  overflow-hidden pr-0.5 hover:scale-105 transition-all duration-300 "
                    }
                    /> */}
        {/* {
          src.includes("?crop=") ?
        <CroppedPreview isPdf={isPdf} imageUrl={src} />
          
          :
          <>

        <CroppedPreview isPdf={isPdf} imageUrl={src} />

                    </>
        } */}
        <CroppedPreview isPdf={isPdf} imageUrl={src} />
      </div>

      {isActiveBool && (
        <div className="absolute bg-black/40 top-0 left-0 w-full h-full flex items-center justify-center pointer-events-none">
          <Icon icon={"mdi:tick-circle"} width={"32px"} color="teal" />
        </div>
      )}
    </div>
  );
};

export default React.memo(ImgGrid);
